import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

function CardCertification(props) {

    const {t, i18n} = useTranslation();

    const item = props.item;

    const dataFormat = (data) => {
        let _data = data.split('-');
        return _data[2] + '.' + _data[1] + '.' + _data[0];
    }

    return (
        <div className="col-md-6 p-2">
            <div className={'shadow p-2 rounded d-flex align-items-center justify-content-between'}>
                {
                    item?.url != null && <div className="information text-start d-flex flex-column">
                        <object data={item.url} type="application/pdf" height={'250'} className={'img-fluid'}>
                            <p>{item.name}</p>
                        </object>

                        <Link to={item.url} target={'_blank'}
                           className={'nav-link'}>
                            <small>{item.name}
                                <small className="text-secondary">
                                    {' ' + dataFormat(item.data)}
                                </small>
                            </small>
                        </Link>
                    </div>
                }
            </div>
        </div>
    );
}

export default CardCertification;
